import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Directive({ selector: 'input[type=number]' })
export class NoScrollWheelDirective implements OnInit, OnDestroy {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  private handler = (e: WheelEvent) => {
    if (document.activeElement === this.el.nativeElement) {
      e.preventDefault();
    }
  };

  ngOnInit() {
    this.el.nativeElement.addEventListener('wheel', this.handler, { passive: false });
  }

  ngOnDestroy() {
    this.el.nativeElement.removeEventListener('wheel', this.handler);
  }
}
